import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as IconAdmin } from '../../../img/administrador boton-07.svg';

const LinkAdmin = ({ text, link, permission }) => {
    const history = useHistory()
    const location = useLocation()
    const { adminMyInfo } = useSelector(state => state.permissionsAdmin)
    const [havePermission, setHavePermission] = useState(false)
    useEffect(() => {
        if (adminMyInfo?._id) {
            const permissions = adminMyInfo.adminRoleId.lenght > 0 ? adminMyInfo.adminRoleId.map(permission => permission.permissionCode).flat() : []
            setHavePermission(permissions.includes(permission))
            setHavePermission(true)

        }


        return () => {

        }
    }, [adminMyInfo])

    // const havePermission = 
    return (
        < >{
            havePermission && (
                <div className={`item-navbar-admin ${location.pathname.includes(link) ? 'active' : ''}`}>
                    <div className="admin-icon-svg">
                        <IconAdmin className="fill-parent " width="15" height="15" />
                    </div>
                    <div onClick={() => history.push(link)} className="title-navbar-item">
                        {text}
                    </div>
                </div>
            )
        }

        </>
    )
}

export default LinkAdmin